import { api } from 'api/common'
import { createActionsHook } from 'react-redux-actions-hook'
import { setToastMessage } from '../../components/app/actions'
import {
    GET_USER_ACTIVITY_TIME,
    GET_USER_LOGGED_IN_ACTIVITY,
    GET_USER_ACTIVITY_MINUTES,
    ALL_USERS_LIST
} from 'api/constants'
import { AnalyticsActionType } from './constants'

const setUserActivityTimeData = (data) => {
    return { type: AnalyticsActionType.SET_USER_ACTIVITY_TIME, data }
}
const setAllUsersActivityMinutes = (data) => {
    return { type: AnalyticsActionType.SET_ALL_USERS_ACTIVITY_MINUTES, data }
}
const setUserLoggedInActivity = (data) => {
    return { type: AnalyticsActionType.SET_USER_LOGGED_IN_ACTIVITY, data }
}
const setUsersData = (data) => {
    return { type: AnalyticsActionType.SET_USER_DATA, data }
}
const setUserActivityError = (data) => {
    return { type: AnalyticsActionType.SET_USER_ACTIVITY_ERROR, data }
}

export const getUsers = (selectedUser) => {
    return (dispatch, stateFn) => {
        const state = stateFn().user
        api(
            `${ALL_USERS_LIST}`,
            {
                method: 'POST',
                body: JSON.stringify({ "search":selectedUser?selectedUser.label?selectedUser.label:selectedUser:"" }),
            },
            dispatch,
        )
            .then((response) => {
                dispatch(setUsersData(response))
            })
            .catch((error) => {
                //Handle Error
            })
    }
}


export const getUserActivityTime = (data) => {
    return (dispatch) => {
        api(
            `${GET_USER_ACTIVITY_TIME}`,
            {
                method: 'POST',
                body: JSON.stringify({user_id:data}),
            },
            dispatch,
        )
            .then((res) => {
                dispatch(setUserActivityTimeData(res))
                
            })
            .catch((error) => {
                //Handle Error
                dispatch(setUserActivityError(true)
                )
                dispatch(
                    setToastMessage({
                        message: error.message || 'Selected User doesnt have any activity!',
                        type: 'error',
                    }),
                )
            })
    }
}
export const getAllUsersActivityMinutes = () => {
    return (dispatch) => {
        api(
            `${GET_USER_ACTIVITY_MINUTES}`,
            {
                method: 'GET'
            },
            dispatch,
        )
            .then((res) => {
                dispatch(setAllUsersActivityMinutes(res))  
            })
            .catch((error) => {
                
                dispatch(
                    setToastMessage({
                        message: error.message || 'Failed!',
                        type: 'error',
                    }),
                )
            })
    }
}

export const getUserLoggedInActivity = () => {
    return (dispatch) => {
        api(
            `${GET_USER_LOGGED_IN_ACTIVITY}`,
            {
                method: 'GET'
            },
            dispatch,
        )
            .then((res) => {
                dispatch(setUserLoggedInActivity(res))  
            })
            .catch((error) => {
                
                dispatch(
                    setToastMessage({
                        message: error.message || 'Failed!',
                        type: 'error',
                    }),
                )
            })
    }
}



export default createActionsHook({
    setUserActivityTimeData,
    getUserActivityTime,
    getAllUsersActivityMinutes,
    getUserLoggedInActivity,
    getUsers,
    setUserActivityError
})